







import { Vue, Component, Prop } from 'vue-property-decorator';
import { URIs } from '../../../src_server/common/URIs';
import { WebUtils } from '../../utils/WebUtils';
import { LineAuthParam } from '../../../src_server/param/LineAuthParam';
import { MessageDialog } from '../../utils/MessageDialog';
import { buildingData } from '../../../src_server/entity/master/buildingData';

@Component({ components: {} })
export default class LineLoginButton extends Vue {
  private building!: string;

  private css_class = ['d-block', 'py-2', 'px-3', 'w-14rem', 'mt-1'];

  created() {
    sessionStorage.clear();

    const queryBuilding = this.$route.query['building'];
    if (!queryBuilding || queryBuilding instanceof Array) {
      MessageDialog.alert('クエリパラメータにbuildingがセットされていません。');
      MessageDialog.systemError('校舎', 'ログインボタン表示時', queryBuilding);
      return;
    }

    // 存在チェック
    const existBuildingMaster = buildingData.find((item) => item.building_id === queryBuilding);
    if (!existBuildingMaster) {
      MessageDialog.systemError('校舎', 'マスタチェック時', queryBuilding);
      return;
    }

    this.building = queryBuilding;
  }

  lineLogin() {
    let redirectPath = WebUtils.getQueryItem('redirect', location);
    if (!redirectPath) {
      redirectPath = '/student-dashboard-page';
    }

    let param: LineAuthParam;
    // リダイレクトバスに校舎がある場合に校舎が２重でLINEにわたるため
    if (redirectPath.indexOf('building') > 0) {
      param = {
        loginOrRegist: 'login',
        redirect: redirectPath,
        errorBack: '/',
      };
    } else {
      param = {
        loginOrRegist: 'login',
        building: this.building,
        redirect: redirectPath,
        errorBack: '/',
      };
    }
    location.href = URIs.LINE_AUTH_REDIRECT.setQuery(param).path;
  }
}
